import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceDetail from './components/ServiceDetail';

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ServicesHero />
        <ServiceDetail />
      </main>
      <Footer />
    </div>
  );
}
